import React from 'react';
import { DiscoverEventCardProps } from './types';

import loadable from '@loadable/component';
import {
    BrowseCardHierarchyExperimentValues,
    SearchCardFullClickExperimentValues,
} from '../../types';

//To prevent content flash during loadable fetch of module, importing
//all four directly to test the stableID enrollment approach.
import DiscoverHorizontalEventCard from './Horizontal/DiscoverHorizontalEventCard';
import DiscoverHorizontalFullClickEventCard from './Horizontal/DiscoverHorizontalFullClickEventCard';
import DiscoverVerticalSearchEventCard from './Vertical/DiscoverVerticalSearchEventCard';
import DiscoverVerticalFullClickSearchEventCard from './Vertical/DiscoverVerticalSearchFullClickEventCard';

type EventCardMobileImportMap = Record<
    SearchCardFullClickExperimentValues,
    React.FunctionComponent<DiscoverEventCardProps>
>;

type EventCardDesktopImportMap = Record<
    SearchCardFullClickExperimentValues,
    React.FunctionComponent<DiscoverEventCardProps>
>;

type BrowseCardDesktopImportMap = Record<
    BrowseCardHierarchyExperimentValues,
    React.FunctionComponent<DiscoverEventCardProps>
>;

export const EXPERIMENT_SEARCH_CARD_MAP_MOBILE: EventCardMobileImportMap = {
    [SearchCardFullClickExperimentValues.control]:
        DiscoverVerticalSearchEventCard,
    [SearchCardFullClickExperimentValues.fullClick]:
        DiscoverVerticalFullClickSearchEventCard,
};

export const EXPERIMENT_SEARCH_CARD_MAP_DESKTOP: EventCardDesktopImportMap = {
    [SearchCardFullClickExperimentValues.control]: DiscoverHorizontalEventCard,
    [SearchCardFullClickExperimentValues.fullClick]:
        DiscoverHorizontalFullClickEventCard,
};

export const EXPERIMENT_BROWSE_CARD_MAP_DESKTOP: BrowseCardDesktopImportMap = {
    [BrowseCardHierarchyExperimentValues.control]: loadable(
        () => import('./Vertical/DiscoverVerticalBrowseEventCard'),
    ),
    [BrowseCardHierarchyExperimentValues.hierarchy]: loadable(
        () => import('./Vertical/DiscoverVerticalBrowseHierarchyEventCard'),
    ),
};

export type { DiscoverEventCardProps };
